export default __webpack_public_path__ + "static/media/Tabl_12.c229ed3b.svg";